export const calculateRows = (container: HTMLDivElement) => {
  const paragraphs = Array.from(
    container.querySelectorAll<HTMLParagraphElement>('p[data-paragraph-index]'),
  );

  return paragraphs.map((paragraph) => {
    const spans = Array.from(
      paragraph.querySelectorAll<HTMLSpanElement>('span[data-word]'),
    );

    const grouped = spans.reduce<
      Record<number, { words: string[]; elements: HTMLElement[] }>
    >((acc, span) => {
      const top = span.offsetTop;
      const word = span.dataset.word;
      if (!word) return acc;

      if (!acc[top]) {
        acc[top] = { words: [], elements: [] };
      }

      acc[top].words.push(word);
      acc[top].elements.push(span);
      return acc;
    }, {});

    return Object.entries(grouped)
      .sort(([a], [b]) => Number(a) - Number(b))
      .map(([_, { words, elements }]) => {
        const isInView = elements.some((el) => {
          const rect = el.getBoundingClientRect();
          return rect.top >= 0 && rect.bottom <= window.innerHeight;
        });

        return { words, isInitiallyInView: isInView };
      });
  });
};
